import { ESavedSearchNotificationActionTypes, ISavedSearchNotificationPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setSavedSearchesNotificationVisible = actionGenerator<
  ESavedSearchNotificationActionTypes.Visible,
  ISavedSearchNotificationPayload
>(ESavedSearchNotificationActionTypes.Visible);
